/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React from 'react'
import PropTypes from 'prop-types'

const renderField = ({
  input,
  label,
  placeholder,
  type,
  meta: { touched, error },
  required,
  defaultValue,
  customClassname,
  noValidation,
  autoFocus,
}) => (
  <div
    className={`form__form-group-input-wrap form__form-group-input-wrap--error-above input-wrapper ${customClassname}`}
  >
    <input
      {...input}
      placeholder={placeholder}
      required={required}
      type={type}
      value={defaultValue || input.value}
      // TODO temporary till change of the design
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus={autoFocus}
    />
    <label htmlFor={label}>{label}</label>
    {touched && error && !noValidation && (
      <span
        className="form__form-group-error"
        data-cy="login-form__form-group-error-render-field"
      >
        {error}
      </span>
    )}
  </div>
)

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
}

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
}

export default renderField
